module.exports = __webpack_public_path__ + "static/media/ibd_foot2.434ce446.png";